import template from "./tooltipElement.hbs";

export class TooltipBodyElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.innerHTML = template({
        });
    }

    static get observedAttributes() { return ["data-popper-placement"]; }
    public attributeChangedCallback(name, oldValue, newValue) {
        this._shadowRoot.querySelector("#tooltip").setAttribute("data-popper-placement", this.getAttribute("data-popper-placement"));
    }
}
export function initTooltipBodyWebComponent() {
    window.customElements.define("s6-tooltip-body", TooltipBodyElement);
}
